module.exports = __webpack_public_path__ + "img/BAC.ba268eb7.png";